import styled from "styled-components"
import { initiateGoogleSignIn } from "utils/googleAuth";
import { initiateCleverSignIn } from "utils/cleverAuth";
import { initiateClassLinkSignIn } from "utils/classlinkAuth";
import { initiateMicrosoftSignIn } from "utils/microsoftAuth";
import { useSignIn } from "hooks/useSignIn/useSignIn";
import google from 'assets/googleSignIn.svg';
import clever from 'assets/cleverSignIn.svg';
import classlink from 'assets/classlinkSignIn.svg';
import microsoft from 'assets/microsoftSignIn.svg';
import { Alert, Button as Btn } from "react-bootstrap";

const providers = {
  google: {
    icon: <img src={google} alt="google signin icon" />,
    provider: initiateGoogleSignIn,
    text: "Sign in with Google"
  },
  clever: {
    icon: <img src={clever} alt="clever signin icon" />,
    provider: initiateCleverSignIn,
    text: "Sign in with Clever"
  },
  classlink: {
    icon: <img src={classlink} alt="classlink signin icon" />,
    provider: initiateClassLinkSignIn,
    text: "Sign in with ClassLink"
  },
  microsoft: {
    icon: <img src={microsoft} alt="microsoft signin icon" />,
    provider: initiateMicrosoftSignIn,
    text: "Sign in with Microsoft"
  }
}

export const SignInButton = ({
  providerOption,
  redirectUri,
  isEducator = false,
  isSignUp = false
}) => {
  const { icon, provider, text } = providers[providerOption]
  const { isLoading, signIn, error } = useSignIn({
    provider,
    redirectUri,
    additionalState: { isEducator, isSignUp }
  })

  return (
    <>
      <Button
        variant="light"
        type="button"
        onClick={signIn}
        disabled={isLoading}
      >
        {icon}
        {text}
      </Button>

      {error && (
        <Alert className="mt-2" color={"danger"}>
          {error}
        </Alert>
      )}
    </>
  )
}

const Button = styled(Btn)`
  border: 1px solid #747775;
  font-size: 0.875rem;
  font-weight: 500;
  max-width: 266px;
  width: 100%;
  height: 40px;
  gap: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
`
